// La quantité qui SORT un produit de l'alerte, et elle est calculée à un seul endroit.
//
// 🔴 POURQUOI UNE FONCTION PARTAGÉE PLUTÔT QUE DEUX FOIS LA MÊME LIGNE. Deux
// chemins commandent les produits sous le seuil — le sélecteur ouvert depuis
// l'écran Produits, et le bouton « Produits en alerte » du formulaire de
// commande. Recopiée, la formule diverge : elle l'avait déjà fait ici, le
// sélecteur proposant **1** là où le dialogue d'ajustement propose « combler ».
// Deux écrans qui commandent le même produit en alerte annonçaient deux
// quantités différentes. *C'est le motif du vocabulaire de règlement, vu pour
// la cinquième fois : tant qu'une valeur peut s'écrire à la main, elle sera
// réécrite de mémoire.*
//
// 🔴 LE « + 1 » N'EST PAS UNE MARGE DE CONFORT, C'EST LA DÉFINITION DE L'ALERTE.
// Le stock bas vaut `current_stock <= min_stock` côté serveur — mesuré à cinq
// endroits concordants (`stock_utils`, `dashboard` ×2, `products`, `to_dict`),
// et le filtre `low_stock_only` emploie la même comparaison inclusive. Combler
// jusqu'au seuil EXACT laisserait donc le produit **en alerte** : on
// commanderait, et la ligne resterait teintée. *Un bouton qui ne fait pas ce
// que son nom annonce est pire que pas de bouton.*
//
// ⚠️ `seuil > 0` REPREND LA CONDITION DU SERVEUR : un seuil à zéro veut dire
// « aucun seuil défini », pas « seuil atteint ». Sans elle, un produit sans
// seuil se verrait proposer de commander 1.

/**
 * Quantité à commander pour sortir le produit de l'alerte, ou 0 s'il n'y est pas.
 * Accepte un produit servi par l'API (`current_stock`, `min_stock`).
 */
export function quantiteACombler(produit) {
  const stock = Number(produit?.current_stock) || 0;
  const seuil = Number(produit?.min_stock) || 0;
  return seuil > 0 && stock <= seuil ? seuil - stock + 1 : 0;
}

/** Le produit est-il en alerte, au sens exact du serveur ? */
export function estEnAlerte(produit) {
  return quantiteACombler(produit) > 0;
}
